import { render } from "./TestView2.vue?vue&type=template&id=6f98c439&scoped=true"
import script from "./TestView2.vue?vue&type=script&lang=js"
export * from "./TestView2.vue?vue&type=script&lang=js"

import "./TestView2.vue?vue&type=style&index=0&id=6f98c439&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f98c439"]])

export default __exports__